import { render, staticRenderFns } from "./UserCoinCollection.vue?vue&type=template&id=7f0a5ec0&"
import script from "./UserCoinCollection.vue?vue&type=script&lang=js&"
export * from "./UserCoinCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports